<template>
  <div style="background-color: #eef3ea; min-height: 100vh;">
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FF6907" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap justify-start pa-5 class="snake-report-shell">
          <v-flex xs12>
            <v-card class="snake-hero-card pa-5" flat>
              <div class="snake-hero-card__eyebrow">SARPA Snake Rescue Desk</div>
              <div class="snake-hero-card__header">
                <div>
                  <span class="heading heading--hero">Snake Reports</span>
                  <div class="snake-hero-card__subtitle">
                    Review all snake incidents, switch status views instantly, and open each report without leaving this page.
                  </div>
                </div>
                <div class="snake-hero-card__stats">
                  <div class="snake-hero-card__stat">
                    <span class="snake-hero-card__label">Active View</span>
                    <strong>{{ activeStatusCard.title }}</strong>
                  </div>
                  <div class="snake-hero-card__stat">
                    <span class="snake-hero-card__label">This Page</span>
                    <strong>{{ items.length }}</strong>
                  </div>
                </div>
              </div>
            </v-card>
          </v-flex>
          <v-flex xs12>
          <v-layout wrap class="my-4 status-container" justify-start>
            <v-flex v-for="(card, i) in statusCards" :key="i" class="pa-2 status-flex-item">
              <v-card @click="applyStatusFilter(card)"
                :class="['stat-card stat-card--clickable d-flex flex-column justify-space-between pa-4', { 'active-stat-card': card.key === activeStatus }]" 
                :style="activeStatus === card.key ? { border: `2px solid ${card.textColor} !important`, background: '#ffffff !important' } : {}"
                flat>
                <div class="stat-card__head">
                  <span class="stat-card__label">{{ card.title }}</span>
                  <v-icon :color="card.textColor" size="22">{{ card.icon }}</v-icon>
                </div>
                <div class="stat-card__value" :style="{ color: card.textColor }">
                  {{ statusCounts[card.countKey] || 0 }}
                </div>
                <div class="stat-card__caption mt-2" style="font-size: 11px; color: #64748B;">
                  {{ card.caption }}
                </div>
              </v-card>
            </v-flex>
          </v-layout>
          </v-flex>


      
          <v-flex xs12 class="mb-5">
            <v-card class="filter-box-premium pa-5" flat>
              <div class="subheading font-weight-bold mb-3" style="color: #334155; display: flex; align-items: center;">
                <v-icon color="#FF6907" class="mr-2">mdi-filter-variant</v-icon>
                <span>Filter Reports</span>
              </div>
              
              <!-- Checkbox Group row -->
              <v-layout wrap class="mb-4">
                <v-flex class="text-left subheading" shrink>
                  <v-checkbox
                    v-model="alldata"
                    label="All"
                    @change="checkUpdate()"
                    class="small-checkbox no-space px-2 mt-0"
                    hide-details
                    color="#FF6907"
                  ></v-checkbox>
                </v-flex>
                <v-flex class="text-left subheading" shrink>
                  <v-checkbox
                    v-model="timeperiod"
                    label="Time Period"
                    :disabled="alldata"
                    class="small-checkbox no-space px-2 mt-0"
                    hide-details
                    color="#FF6907"
                  ></v-checkbox>
                </v-flex>
                <v-flex class="text-left subheading" shrink>
                  <v-checkbox
                    v-model="allsnakes"
                    label="All Snakes"
                    :disabled="alldata"
                    class="small-checkbox no-space px-2 mt-0"
                    hide-details
                    color="#FF6907"
                  ></v-checkbox>
                </v-flex>
                <v-flex class="text-left subheading" shrink>
                  <v-checkbox
                    v-model="bigsnakes"
                    label="District"
                    :disabled="alldata"
                    class="small-checkbox no-space px-2 mt-0"
                    hide-details
                    color="#FF6907"
                  ></v-checkbox>
                </v-flex>
                <v-flex class="text-left subheading" shrink>
                  <v-checkbox
                    v-model="users"
                    label="Situation"
                    :disabled="alldata"
                    class="small-checkbox no-space px-2 mt-0"
                    hide-details
                    color="#FF6907"
                  ></v-checkbox>
                </v-flex>
              </v-layout>

              <!-- Inputs row -->
              <v-layout wrap class="mx-n2" v-if="timeperiod || bigsnakes || allsnakes || users">
                <v-flex xs12 sm4 md4 lg4 class="subheading px-2 mb-3" v-if="timeperiod">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span class="smallHeading d-block mb-1">From Date</span>
                      <v-text-field
                        v-model="fromdate"
                        label="From Date"
                        append-icon="mdi-calendar"
                        readonly
                        outlined
                        dense
                        hide-details="true"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="alldata"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fromdate"
                      :active-picker.sync="activePicker"
                      :max="
                        new Date(
                          Date.now() - new Date().getTimezoneOffset() * 60000
                        )
                          .toISOString()
                          .substring(0, 10)
                      "
                      min="1950-01-01"
                      @change="save"
                      color="#FF6907"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                
                <v-flex xs12 sm4 md4 lg4 class="subheading px-2 mb-3" v-if="timeperiod">
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span class="smallHeading d-block mb-1">To Date</span>
                      <v-text-field
                        v-model="todate"
                        label="To Date"
                        append-icon="mdi-calendar"
                        readonly
                        outlined
                        dense
                        hide-details="true"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="alldata"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="todate"
                      :active-picker.sync="activePickerto"
                      :max="
                        new Date(
                          Date.now() - new Date().getTimezoneOffset() * 60000
                        )
                          .toISOString()
                          .substring(0, 10)
                      "
                      min="1950-01-01"
                      @change="saveto"
                      color="#FF6907"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm4 md4 lg4 class="subheading px-2 mb-3" v-if="bigsnakes">
                  <span class="smallHeading d-block mb-1">Select District</span>
                  <v-select
                    :items="districts"
                    v-model="bigsnakeselect"
                    multiple
                    chips
                    deletable-chips
                    outlined
                    dense
                    hide-details="true"
                    :disabled="alldata"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm4 md4 lg4 class="subheading px-2 mb-3" v-if="allsnakes">
                  <span class="smallHeading d-block mb-1">Select Snakes</span>
                  <v-select
                    :items="snakeitems"
                    v-model="allsnakelist"
                    multiple
                    item-text="name"
                    item-value="_id"
                    outlined
                    dense
                    hide-details="true"
                    :disabled="alldata"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm4 md4 lg4 class="subheading px-2 mb-3" v-if="users">
                  <span class="smallHeading d-block mb-1">Select Situation</span>
                  <v-select
                    :items="situationlist"
                    v-model="selecteduser"
                    outlined
                    :disabled="alldata"
                    dense
                    hide-details="true"
                  ></v-select>
                </v-flex>
              </v-layout>

              <!-- Action buttons inside the same filter card -->
              <v-layout wrap class="mt-3" v-if="timeperiod || bigsnakes || allsnakes || users">
                <v-flex xs12>
                  <v-btn
                    color="#FF6907"
                    depressed
                    @click="getData()"
                    :disabled="alldata"
                    class="mr-2 btn-submit-premium"
                    dark
                  >
                    <v-icon left small>mdi-check</v-icon>
                    <span>Submit</span>
                  </v-btn>
                
                  <v-btn
                    outlined
                    color="#64748B"
                    @click="reset()"
                    :disabled="alldata"
                    class="btn-reset-premium"
                  >
                    <v-icon left small>mdi-refresh</v-icon>
                    <span>Reset</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-flex xs12>
            <v-layout wrap justify-start pt-2 v-if="items && items.length > 0">
              <v-flex xs12>
                <v-card class="premium-table-card" flat>
                  <div class="table-toolbar">
                    <div>
                      <div class="table-toolbar__title">{{ activeStatusCard.title }} Reports</div>
                      <div class="table-toolbar__subtitle">{{ resultsSummary }}</div>
                    </div>
                    <v-btn
                      v-if="activeStatus !== 'total'"
                      text
                      color="#FF6907"
                      class="table-toolbar__button"
                      @click="clearStatusFilter"
                    >
                      <v-icon left small>mdi-filter-remove-outline</v-icon>
                      Show All
                    </v-btn>
                  </div>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center tableheading">Reported Date</th>
                          <th class="text-center tableheading">Reported Time</th>
                          <th class="text-center tableheading">Division</th>
                          <th class="text-center tableheading">District</th>
                          <th class="text-center tableheading">Description</th>
                          <th class="text-center tableheading">Situation</th>
                          <th class="text-center tableheading">Snake</th>
                          <th class="text-center tableheading">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in items"
                          :key="index"
                          class="text-center report-row"
                          @click="openviewdetails(item)"
                          style="cursor: pointer;"
                        >
                          <td class="font-weight-medium">{{ formatDate(item.reportedAt) }}</td>
                          <td class="font-weight-medium">{{ formatTime(item.reportedAt) }}</td>
                          <td>
                            <span>{{ formatDivision(item) }}</span>
                          </td>
                          <td>
                            <span v-if="item && (item.reportId.district || item.rescue.district)">
                              {{ item.reportId.district || item.rescue.district }}
                            </span>
                            <span v-else class="grey--text">-</span>
                          </td>
                          <td>
                            <span v-if="item && item.reportId.description">{{ item.reportId.description }}</span>
                            <span v-else class="grey--text">-</span>
                          </td>
                          <td>
                            <span v-if="item && item.reportId.situation">{{ item.reportId.situation }}</span>
                            <span v-else class="grey--text">-</span>
                          </td>
                          <td style="text-transform: capitalize" class="font-weight-medium">
                            <span v-if="item && item.reportId.snake && item.reportId.snake.name">{{ item.reportId.snake.name }}</span>
                            <span v-else class="grey--text">-</span>
                          </td>
                          <td>
                            <span :class="['status-badge', 'status-' + item.status.toLowerCase().replace(/[\s_]+/g, '')]">{{ item.status }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 pb-4 v-if="items && items.length > 0">
        <v-layout wrap justify-center>
          <v-flex xs10>
            <v-pagination
              v-model="currentPage"
              :length="Pagelength"
              :total-visible="7"
              circle
              color="#FF6907"
              small
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 v-else>
        <v-layout wrap justify-center class="px-5 pb-6">
          <v-flex xs12>
            <v-card class="empty-state-card pa-8 text-center" flat>
              <v-icon size="40" color="#94A3B8">mdi-file-search-outline</v-icon>
              <div class="empty-state-card__title">No reports found</div>
              <div class="empty-state-card__subtitle">{{ emptyStateMessage }}</div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog v-model="deleteDialog" max-width="500">
      <v-card>
        <v-card-title class="heading">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            tile
            outlined
            color="#FF1313"
            light
            :ripple="false"
            depressed
            @click="deleteDialog = false"
            class="itemValue"
          >
            Cancel
          </v-btn>
          <v-btn
            tile
            :color="appColor"
            light
            :ripple="false"
            depressed
            @click="deleteoperation()"
            class="itemValue"
          >
            <span style="color: #fff">Submit</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="rejectDialog" max-width="500">
      <v-card>
        <v-card-title class="heading">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to reject?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            tile
            outlined
            color="#FF1313"
            light
            :ripple="false"
            depressed
            @click="rejectDialog = false"
            class="itemValue"
          >
            Cancel
          </v-btn>
          <v-btn
            tile
            :color="appColor"
            light
            :ripple="false"
            depressed
            @click="rejectoperation()"
            class="itemValue"
          >
            <span style="color: #fff">Submit</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
          <script>
import axios from "axios";
export default {
  data() {    
    const pageKey = this.$route.name || 'defaultPage';
    return {
      statusCounts: {
        total: 0,
        pending: 0,
        assigned: 0,
        rescued: 0,
        released: 0,
        approved: 0,
        fraud: 0,
      },
      statusCards: [
        { key: "total", title: "Total", caption: "All reports", icon: "mdi-database-outline", textColor: "#1D4ED8", countKey: "total", filterValue: "" },
        { key: "pending", title: "Pending", caption: "Awaiting action", icon: "mdi-clock-outline", textColor: "#EA580C", countKey: "pending", filterValue: "Pending" },
        { key: "assigned", title: "Assigned", caption: "Tasked to rescuer", icon: "mdi-account-check-outline", textColor: "#0EA5E9", countKey: "assigned", filterValue: "Assigned" },
        { key: "rescued", title: "Rescued", caption: "Rescue completed", icon: "mdi-heart-pulse", textColor: "#22C55E", countKey: "rescued", filterValue: "Rescued" },
        { key: "released", title: "Released", caption: "Released safely", icon: "mdi-map-marker-radius-outline", textColor: "#A855F7", countKey: "released", filterValue: "Released" },
        { key: "approved", title: "Approved", caption: "Approved operations", icon: "mdi-check-circle-outline", textColor: "#0F766E", countKey: "approved", filterValue: "Approved" },
        { key: "fraud", title: "Fraud", caption: "Marked suspicious", icon: "mdi-alert-octagon-outline", textColor: "#E11D48", countKey: "fraud", filterValue: "Fraud" },
      ],

      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      count: 20,
      keyword: "",
      pageKey,
      currentPage: 1,
      Pagelength: 0,
      userlist: [],
      items: [],
      snakeitems: [],
      status: "",
      activeStatus: "total",
      deleteDialog: false,
      deleteid: "",
      rejectDialog: false,
      rejectid: "",
      districts: [
        "All",
        "Palakkad",
        "Alappuzha",
        "Malappuram",
        "Kannur",
        "Wayanad",
        "Kozhikode",
        "Thrissur",
        "Thiruvananthapuram",
        "Kottayam",
        "Idukki",
        "Ernakulam",
        "Kollam",
        "Pathanamthitta",
        "Kasaragod",
      ],
      alldata: true,
      timeperiod: false,
      bigsnakes: false,
      allsnakes: false,
      users: false,
      activePicker: null,
      fromdate: null,
      menu: false,
      activePickerto: null,
      todate: null,
      menu2: false,
      bigsnakeselect: [],
      allsnakelist: "",
      selecteduser: "",
      bigsnakestypes: [],
      situationlist: [
        "Inside the house",
        "Just outside the building",
        "Natural habitat",
        "Inside Residential Building",
        "Outside Residential Building",
        "Inside Non Residential Building",
        "Outside Non Residential Building",
      ],
      casestatus: false,
      casestatusdata: "",
    };
  },
  computed: {
    activeStatusCard() {
      return this.statusCards.find((card) => card.key === this.activeStatus) || this.statusCards[0];
    },
    resultsSummary() {
      const activeLabel = this.activeStatusCard.title.toLowerCase();
      const message = this.activeStatus === "total"
        ? "Showing all snake operation reports"
        : `Showing ${activeLabel} snake operation reports`;

      return `${message}. ${this.items.length} record${this.items.length === 1 ? "" : "s"} visible on this page.`;
    },
    emptyStateMessage() {
      if (this.activeStatus !== "total") {
        return `No ${this.activeStatusCard.title.toLowerCase()} reports match the current filters.`;
      }

      return "Try changing the date, district, snake, or situation filters to widen the results.";
    },
  },
  beforeMount() {
    this.getData();
    this.getList();
  },
  watch: {
    currentPage() {
      this.getData();
    },
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePickerto = "YEAR"));
    },
    count() {
      this.getData();
    },
    keyword() {
      this.getData();
    },
  },
  methods: {
    formatSnakeReportDateTime(date) {
      if (!date) return null;
      const parsedDate = new Date(date);
      if (isNaN(parsedDate.getTime())) return null;

      return {
        date: new Intl.DateTimeFormat("en-GB", {
          timeZone: "Asia/Kolkata",
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }).format(parsedDate),
        time: new Intl.DateTimeFormat("en-IN", {
          timeZone: "Asia/Kolkata",
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        }).format(parsedDate),
      };
    },
    getDetailPath() {
      if (this.$route.path && this.$route.path.startsWith("/officers/")) {
        return "/officers/snakereportsview";
      }

      return "/snakereportsview";
    },
    applyStatusFilter(card) {
      if (!card) {
        return;
      }

      const nextStatus = card.key;
      const nextFilter = card.filterValue || "";

      this.activeStatus = nextStatus;
      this.casestatusdata = nextFilter;

      if (this.currentPage !== 1) {
        this.currentPage = 1;
        return;
      }

      this.getData();
    },
    clearStatusFilter() {
      this.applyStatusFilter(this.statusCards[0]);
    },

    getCounts() {
      axios({
        method: "GET",
        url: "/operation/getlist/count",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          fromDate: this.fromdate,
          toDate: this.todate,
          snake: this.allsnakelist,
          districts: this.bigsnakeselect,
          situation: this.selecteduser,
        },
      })
        .then((response) => {
          if (response.data.status === true && response.data.count) {
            const counts = response.data.count;

            // Map the API response counts to your component's statusCounts state
            this.statusCounts.total = counts.Total || counts.total || 0;
            this.statusCounts.pending = counts.Pending || 0;
            this.statusCounts.assigned = counts.Assigned || 0;
            this.statusCounts.rescued = counts.Rescued || 0;
            this.statusCounts.released = counts.Released || 0;
            this.statusCounts.approved = counts.Approved || 0;
            this.statusCounts.fraud = counts.Fraud || 0;

          }
        })
        .catch((err) => {
          console.error("Failed to fetch statistics counts:", err);
        });
    },


    openviewdetails(item) {
      this.$router.push({
        path: this.getDetailPath(),
        query: {
          id: item._id,
        },
      });
    },

    //   opendeleteDialog(item) {
    //     this.deleteid = item.operation._id;
    //     this.deleteDialog = true;
    //   },
    openrejectDialog(item) {
      this.rejectid = item._id;
      this.rejectDialog = true;
    },
    checkUpdate() {
      if (this.alldata == true) {
        this.timeperiod = false;
        this.bigsnakes = false;
        this.casestatus = false;
        this.allsnakes = false;
        this.users = false;
        this.fromdate = null;
        this.todate = null;
        this.bigsnakeselect = [];
        this.allsnakelist = [];
        this.selecteduser = "";
        if (this.currentPage !== 1) {
          this.currentPage = 1;
          return;
        }
        this.getData();
      }
    },
    reset() {
      // Reset all checkboxes
      this.timeperiod = false;
      this.bigsnakes = false;
      this.allsnakes = false;
      this.users = false;

      // Reset date pickers
      this.fromdate = null;
      this.todate = null;

      // Reset big snake selection
      this.bigsnakeselect = [];

      // Reset all snake list
      this.allsnakelist = [];

      // Reset user selection
      this.selecteduser = "";
      if (this.currentPage !== 1) {
        this.currentPage = 1;
        return;
      }
      this.getData();

      // You can also trigger any other actions if needed
      // this.msg = "Fields have been reset";
      // this.showSnackBar = true;
    },
    save(fromdate) {
      this.$refs.menu.save(fromdate);
    },
    saveto(todate) {
      this.$refs.menu2.save(todate);
    },
    getData() {
      this.appLoading = true;
      this.getCounts(); //Fetch statistics counts alongside the list data
      axios({
        method: "GET",
        url: "/operation/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
          fromDate: this.fromdate,
          toDate: this.todate,
          snake: this.allsnakelist,
          districts: this.bigsnakeselect,
          situation: this.selecteduser,
          status: this.casestatusdata,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.items = response.data.data;
              this.Pagelength = response.data.pages;
              // this.msg = response.data.msg;
              // this.showSnackBar = true;
              this.appLoading = false;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
    getList() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/snake/all/",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.snakeitems = response.data.data;
              this.appLoading = false;
              // this.msg = response.data.msg;
              // this.showSnackBar = true;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
    deleteoperation() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/operation/delete",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.deleteid,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.msg = "Deleted Successfully.";
              this.showSnackBar = true;
              this.appLoading = false;
              this.deleteDialog = false;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
            this.deleteDialog = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    rejectoperation() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/operation/removedeleterequest",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.rejectid,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.msg = "Rejected Successfully.";
              this.showSnackBar = true;
              this.appLoading = false;
              this.rejectDialog = false;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
            this.rejectDialog = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(date) {
      const formatted = this.formatSnakeReportDateTime(date);
      return formatted ? formatted.date : "-";
    },
    formatTime(date) {
      const formatted = this.formatSnakeReportDateTime(date);
      return formatted ? formatted.time : "-";
    },
    formatDivision(item) {
      if (!item) return "-";
      const division = item.division || (item.reportId && (item.reportId.divisionuser || item.reportId.division));
      if (!division) return "-";
      if (Array.isArray(division)) {
        const valid = division.filter(d => {
          if (d === null || d === undefined) return false;
          let name = "";
          let type = "";
          if (typeof d === 'object') {
            name = d.divisionName || "";
            if (d.belongsTo && d.belongsTo.circleType) {
              type = d.belongsTo.circleType;
            }
          } else {
            name = d;
          }
          name = name.toUpperCase();
          
          if (type) {
            return type === "1" || type === "2";
          }
          
          return !name.includes("SOCIAL FORESTRY") && 
                 !name.includes("FLYING SQUAD") && 
                 !name.includes("VIGILANCE");
        });
        if (!valid.length) return "-";
        return valid.map(d => typeof d === 'object' && d.divisionName ? d.divisionName : d).join(", ");
      }
      
      let name = "";
      let type = "";
      if (typeof division === 'object') {
        name = division.divisionName || "";
        if (division.belongsTo && division.belongsTo.circleType) {
          type = division.belongsTo.circleType;
        }
      } else {
        name = division;
      }
      name = name.toUpperCase();
      
      const isMatch = type ? (type === "1" || type === "2") : 
        (!name.includes("SOCIAL FORESTRY") && !name.includes("FLYING SQUAD") && !name.includes("VIGILANCE"));
        
      if (isMatch) {
        return typeof division === 'object' && division.divisionName ? division.divisionName : division;
      }
      return "-";
    },
  },
};
</script>
          <style>
.heading {
  font-family: poppinsregular;
  font-size: 20px;
  font-weight: 900;
}
.subheading {
  font-family: poppinsregular;
  font-size: 15px;
  font-weight: 500;
}
.snake-report-shell {
  gap: 8px;
}
.heading--hero {
  color: #102A1C;
  display: block;
  margin-bottom: 8px;
}
.snake-hero-card {
  background: linear-gradient(135deg, #F8FCF6 0%, #EEF7EC 100%) !important;
  border: 1px solid rgba(16, 42, 28, 0.08) !important;
  border-radius: 24px !important;
  box-shadow: 0 18px 40px rgba(16, 42, 28, 0.08) !important;
}
.snake-hero-card__eyebrow {
  color: #4D6B57;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
  margin-bottom: 14px;
  text-transform: uppercase;
}
.snake-hero-card__header {
  align-items: flex-end;
  display: flex;
  gap: 20px;
  justify-content: space-between;
}
.snake-hero-card__subtitle {
  color: #4B6353;
  font-size: 14px;
  line-height: 1.6;
  max-width: 720px;
}
.snake-hero-card__stats {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;
}
.snake-hero-card__stat {
  background: rgba(255, 255, 255, 0.82);
  border: 1px solid rgba(77, 107, 87, 0.14);
  border-radius: 18px;
  min-width: 150px;
  padding: 14px 16px;
}
.snake-hero-card__label {
  color: #6A7F70;
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  margin-bottom: 6px;
  text-transform: uppercase;
}
.tableheading {
  font-family: poppinsregular;
  font-size: 15px !important;
  color: black !important;
  text-transform: uppercase !important;
}
.tablesubheading {
  font-family: poppinsregular;
  font-size: 10px;
}

/* status cards */
/* Responsive Single-line Row for Large Desktop Screens */
@media (min-width: 1264px) {
  .status-container {
    flex-wrap: nowrap !important;
  }
  .status-flex-item {
    flex: 1 1 0px !important;
    max-width: 14.28% !important; /* Divides row equally among 7 cards */
  }
}

/* Fallback wrapping layouts for smaller screens */
@media (max-width: 1263px) and (min-width: 960px) {
  .status-flex-item {
    flex: 0 0 25% !important;
    max-width: 25% !important;
  }
}
@media (max-width: 959px) and (min-width: 600px) {
  .status-flex-item {
    flex: 0 0 33.33% !important;
    max-width: 33.33% !important;
  }
}
@media (max-width: 599px) {
  .status-flex-item {
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }
}

/* Premium Card Styles matching the requested design */
.stat-card {
  background: rgba(255, 255, 255, 0.96) !important;
  border: 1px solid rgba(34, 64, 35, 0.08) !important;
  border-radius: 20px !important;
  box-shadow: 0 16px 28px rgba(18, 42, 24, 0.08) !important;
  padding: 16px 18px !important;
  cursor: pointer;
  height: 125px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.stat-card--clickable:hover {
  transform: translateY(-4px);
  background: #ffffff !important;
  border-color: rgba(46, 90, 56, 0.3) !important;
  box-shadow: 0 20px 35px rgba(18, 42, 24, 0.12) !important;
}

.stat-card__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.stat-card__label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6c7c6c;
}

.stat-card__value {
  margin-top: 12px;
  font-size: 28px;
  line-height: 1;
  font-weight: 700;
}

.active-stat-card {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 20px 35px rgba(18, 42, 24, 0.15) !important;
}

/* Premium Filter Box */
.filter-box-premium {
  background: #ffffff !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03) !important;
}

/* Premium Table Container */
.premium-table-card {
  border-radius: 16px !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04) !important;
  overflow: hidden !important;
}
.table-toolbar {
  align-items: center;
  border-bottom: 1px solid #E2E8F0;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  padding: 18px 20px 14px;
}
.table-toolbar__title {
  color: #102A1C;
  font-size: 18px;
  font-weight: 800;
}
.table-toolbar__subtitle {
  color: #64748B;
  font-size: 13px;
  margin-top: 4px;
}
.table-toolbar__button {
  font-weight: 700 !important;
  text-transform: none !important;
}

.premium-table-card th {
  background-color: #f8fafc !important;
  color: #475569 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  font-size: 13px !important;
  letter-spacing: 0.5px !important;
  border-bottom: 2px solid #edf2f7 !important;
  padding: 16px 12px !important;
}

.premium-table-card td {
  padding: 14px 12px !important;
  font-size: 14px !important;
  color: #334155 !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

.premium-table-card tbody tr:hover {
  background-color: rgba(255, 105, 7, 0.03) !important;
  transition: background-color 0.2s ease !important;
}

/* Status Badges */
.status-badge {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 6px 12px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  border-radius: 20px !important;
  text-transform: capitalize !important;
  letter-spacing: 0.3px !important;
}

.status-pending {
  background-color: #FFF3E0 !important;
  color: #E65100 !important;
}

.status-assigned {
  background-color: #E3F2FD !important;
  color: #0D47A1 !important;
}

.status-rescued {
  background-color: #E8F5E9 !important;
  color: #1B5E20 !important;
}

.status-released {
  background-color: #F3E5F5 !important;
  color: #4A148C !important;
}

.status-approved {
  background-color: #E0F2F1 !important;
  color: #004D40 !important;
}

.status-fraud, .status-fraudcase {
  background-color: #FFEBEE !important;
  color: #B71C1C !important;
}
.empty-state-card {
  align-items: center;
  background: #FFFFFF !important;
  border: 1px dashed #CBD5E1 !important;
  border-radius: 20px !important;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.empty-state-card__title {
  color: #102A1C;
  font-size: 20px;
  font-weight: 800;
}
.empty-state-card__subtitle {
  color: #64748B;
  font-size: 14px;
  line-height: 1.6;
  margin: 0 auto;
  max-width: 480px;
}

/* Premium Buttons */
.btn-submit-premium {
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.2px !important;
  transition: all 0.25s ease !important;
}

.btn-submit-premium:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 105, 7, 0.2) !important;
}

.btn-reset-premium {
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.2px !important;
  transition: all 0.25s ease !important;
}

/* Clickable Row Hover */
.report-row {
  transition: background-color 0.15s ease;
}

.report-row:hover {
  background-color: rgba(255, 105, 7, 0.05) !important;
}


@media (max-width: 959px) {
  .snake-hero-card__header {
    align-items: flex-start;
    flex-direction: column;
  }
  .snake-hero-card__stats {
    justify-content: flex-start;
    width: 100%;
  }
  .table-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
}

</style>
